import { render } from "./EditorCommandMenu.vue?vue&type=template&id=2e60ec23&ts=true&lang=html"
import script from "./EditorCommandMenu.vue?vue&type=script&lang=ts"
export * from "./EditorCommandMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__